import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精心整理的影视专题，一键直达你想看的每一部
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg p-4 md:p-5 cursor-pointer hover:bg-background-200 transition-colors flex flex-col gap-2"
            >
              <div className="flex items-center justify-between">
                <span className="px-2 py-0.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="text-xs text-foreground-400">{item.count}部</span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug">
                {item.title}
              </h3>
              <div className="flex items-center gap-1 text-xs text-accent-500 mt-auto">
                <span>查看合集</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}